<template>
  <vs-tabs position="left" class="tabs-shadow-none">
    <vs-tab icon-pack="feather" icon="icon-zap" label="All guests" v-if="hasPermission('vp.crm.guestprofiles.extended.view')">
      <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
        <UserProfiles />
      </div>
    </vs-tab>
    <vs-tab icon-pack="feather" icon="icon-home" label="Guests by venue" v-if="hasPermission('vp.crm.guestprofiles.view')">
      <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
        <UserProfilesVenue />
      </div>
    </vs-tab>
    <vs-tab icon-pack="feather" icon="icon-link" label="My referrals" v-if="hasPermission('vp.crm.guestprofiles.view')">
      <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
        <UserProfilesReferral />
      </div>
    </vs-tab>
  </vs-tabs>
</template>

<script>
import UserProfiles from "./UserProfiles.vue";
import UserProfilesVenue from "./UserProfilesVenue.vue";
import UserProfilesReferral from "./UserProfilesReferral.vue";

import { mapGetters } from "vuex";

export default {
  components: {
    UserProfiles,
    UserProfilesVenue,
    UserProfilesReferral
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters({})
  }
};
</script>

<style lang="scss">
#profile-tabs {
  .vs-tabs--content {
    padding: 0;
  }
}
</style>